import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { connect } from 'react-redux'
import { customerNameById, formatKennitala, formatKennitalaAsDate } from '../../utils'
import { createPayerVirtualcard, createPayerDepositSlip, removeTempCC } from '../../api/payers/actions'
import { removeVirtualCard } from '../../api/virtual-card/actions'
import { mapProductToPayer } from '../../api/payers/actions'
import CardForm from '../card-form'

import { fetchNationalRegistry } from '../../api/national-registry/actions'

const kennitala = require('kennitala')


class PayerModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            search: '',
            paymentMethod: 'deposit-slip',
            depositSlipPaper: "false",
        }

        this.onChangeCheckbox = this.onChangeCheckbox.bind(this)
        this.onChangeDsPaper = this.onChangeDsPaper.bind(this)
        this.clearPaymentMethod = this.clearPaymentMethod.bind(this)
        this.submitPayer = this.submitPayer.bind(this)
        this.setPayerId = this.setPayerId.bind(this)
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.nationalRegistry.data.find(item => item.OrgId === prevState.search)) {
            return { payerObj: nextProps.nationalRegistry.data.find(item => item.OrgId === prevState.search) };
        }
        else return null;
    }

    componentDidMount(){
        initialInputState();
        let that = this;
        $('#PayerModal').on('hidden.bs.modal', function () {
            that.clearModal();
        });
    }

    componentDidUpdate(){
        initialInputState();
    }

    handleSSN(event) {
        this.setState({
            search: event.target.value
        })
        let onlyLookup = true;

        if (kennitala.isValid(event.target.value)) {
            this.props.dispatch(fetchNationalRegistry(kennitala.clean(event.target.value), onlyLookup))
        }
    }

    onChangeCheckbox(event) {
        this.setState({
            paymentMethod: event.target.value
        })
    }

    onChangeDsPaper(event) {
        this.setState({
            depositSlipPaper: event.target.value
        })
    }

    clearPaymentMethod(){
        $('input[name=payment-method]').prop('checked', false);
        this.setState({
            paymentMethod: ''
        })
    }

    clearModal(){
        setTimeout(() => {
            delete this.state.payerObj;
            this.setState({
                search: '',
                paymentMethod: 'deposit-slip',
            });
    
            this.props.dispatch(removeTempCC(this.props.payerId));
            this.props.dispatch(removeVirtualCard());
        }, 500)
    }

    fillEmptyPaymentMethods(payer){
        if (Object.entries(this.props.payers.payerProductMapping).length === 0) {
            Object.keys(this.props.offers.offerQueryParameters).map((c) => {
                Object.entries(this.props.offers.offerQueryParameters[c]).map(([product, value]) => {
                    let payment = payer.OrgId + "-" + this.state.paymentMethod
                    if (value === true) {
                        this.props.dispatch(mapProductToPayer(c, product, payment))
                    }
                })
            })
        }
    }

    submitPayer(){
        let payer = this.props.nationalRegistry.data.find(item => item.OrgId === this.state.search)
        if (this.props.virtualCard.results) {
            Promise.resolve(this.props.dispatch(createPayerVirtualcard(this.state.paymentMethod, payer, this.props.payers.temporaryCC[payer.OrgId])))
                .then(() => {
                    this.fillEmptyPaymentMethods(payer);
                })
                .then(this.clearModal())
        } else {
            Promise.resolve(this.props.dispatch(createPayerDepositSlip(this.state.paymentMethod, payer, this.state.depositSlipPaper)))
                .then(() => {
                    this.fillEmptyPaymentMethods(payer);
                })
                .then(this.clearModal())
        }
    }

    setPayerId(customerId) {
        this.setState({
            search: customerId
        })
        this.props.dispatch(fetchNationalRegistry(kennitala.clean(customerId), true))
    }

    shouldBeDisabled(){
        let disabledBtn = true;
        if (this.state.payerObj) {
            if ((this.state.paymentMethod === "credit-card" && this.props.virtualCard.status === "virtualcard-received") || this.state.paymentMethod === "deposit-slip" || this.state.paymentMethod === "credit-card-manual") {
                disabledBtn = false
            } else {
                disabledBtn = true
            }
        } else {
            disabledBtn = true
        }
        return disabledBtn;
    }

    render() {

        return (


            <div className="modal payer-modal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel"
                aria-hidden="true" id={this.props.id}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row payer-prefill">
                                { Object.keys(this.props.insuranceTakers.insuranceTakers).filter(k => kennitala.info(k).age > 17).map(customerId => 
                                    <button key={customerId} className="btn btn-outline-secondary" onClick={() => this.setPayerId(customerId)}>{ customerNameById(customerId, this.props.customers) }</button>
                                )}
                            </div>
                            <div className={this.state.payerObj && this.state.payerObj.OrgId ? "container-fluid payer-form ssn-confirm" : "container-fluid payer-form"} id="payer-form">
                                <div className="row payer-search">
                                    <div className="form-group">
                                        <input id="quote-ssn" className="form-control" placeholder="Kennitala" value={this.state.search} type="text" onChange={this.handleSSN.bind(this)} autoFocus />
                                        {/* <label htmlFor="quote-ssn">Kennitala</label> */}
                                    </div>
                                    <div className="name-container">
                                        {this.state.payerObj && <div className="name">{this.state.payerObj.Name}</div>}
                                    </div>
                                </div>
                                <div className="form-row align-items-center payment-container">
                                    <div className={this.state.payerObj && this.state.payerObj.OrgId ? "col-sm-12 col-form-label title" : "col-sm-12 col-form-label title d-none"}>Greiðsluleið</div>
                                    <div className={this.state.payerObj && this.state.payerObj.OrgId ? "options payoptions col" : "options payoptions col d-none" } >
                                        <input className="xs-mt-10" type="radio" id="payment-method-ds" name="payment-method" checked={this.state.paymentMethod === 'deposit-slip'} onChange={this.onChangeCheckbox} value="deposit-slip" />
                                        <label htmlFor="payment-method-ds" className="col-sm-3 col-form-label">Greiðsluseðill</label>
                                    </div>
                                    {/* <div className={this.state.payerObj && this.state.payerObj.OrgId ? "options payoptions col" : "options payoptions col d-none" } >
                                        <input type="radio" id="payment-method-cc" name="payment-method" checked={this.state.paymentMethod === 'credit-card-manual'} onClick={this.onChangeCheckbox} value="credit-card-manual" />
                                        <label htmlFor="payment-method-cc" className="col-sm-3 col-form-label">Kreditkort</label>
                                    </div> */}
                                    <div className={this.state.payerObj && this.state.payerObj.OrgId ? "options payoptions col" : "options payoptions col d-none" } >
                                        <input className="xs-mt-10" type="radio" id="payment-method-cc" name="payment-method" checked={this.state.paymentMethod === 'credit-card'} onChange={this.onChangeCheckbox} value="credit-card" />
                                        <label htmlFor="payment-method-cc" className="col-sm-3 col-form-label">Kreditkort</label>
                                    </div>

                                </div>
                            
                                {this.state.paymentMethod && this.state.paymentMethod === "credit-card-manual" && 
                                    <div className="card-container">
                                        Rafræn skráning korta er í vinnslu. Vinsamlegast fyllið út greiðslubeiðni á pappír
                                    </div>
                                }

                                {this.state.paymentMethod && this.state.paymentMethod === "credit-card" && 
                                    <div className="card-container">
                                        {/* Rafræn skráning korta er í vinnslu. Vinsamlegast fyllið út greiðslubeiðni á pappír */}
                                        <CardForm className="card-form" virtualCard={this.props.virtualCard} payerId={this.state.payerObj.OrgId} dispatch={this.props.dispatch} payers={this.props.payers} />
                                    </div>
                                }
                                {this.state.paymentMethod && this.state.paymentMethod === "deposit-slip" && 
                                <div className="form-row options col-sm-12">
                                    <div className="col-12">
                                        <i>ATH - greitt er þjónustugjald fyrir stofnun á kröfu að fjárhæð 125 ISK</i>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-check">
                                            <input type="radio" className="form-check-input" id="deposit-slip-paper-no" name="deposit-slip-paper" checked={this.state.depositSlipPaper === "false"} onChange={this.onChangeDsPaper} value="false" />
                                            <label htmlFor="deposit-slip-paper-no" className="form-check-label">Sleppa greiðsluseðlum - þeir birtast í heimabanka greiðanda</label>
                                        </div>
                                        <div className="form-check">
                                            <input type="radio" className="form-check-input" id="deposit-slip-paper-yes" name="deposit-slip-paper" checked={this.state.depositSlipPaper === "true"} onChange={this.onChangeDsPaper} value="true" />
                                            <label htmlFor="deposit-slip-paper-yes" className="form-check-label">Senda á heimilisfang greiðanda</label>
                                        </div>
                                    </div>
                                </div>
                                }
                            </div>
                            <button disabled={this.shouldBeDisabled()} className="btn btn-primary" type="button" onClick={this.submitPayer} data-dismiss="modal">Vista greiðanda</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

PayerModal.defaultProps = {
}

function mapStateToProps(state) {

    var f = {
        customers: {},
        offers: {},
        gui: {},
        currency: {},
        nationalRegistry: {},
        virtualCard: {},
        payers: {},
        insuranceTakers: {},
    }
    f.customers = (state.customers === undefined) ? {} : state.customers
    f.offers = (state.offers === undefined) ? {} : state.offers
    f.gui = (state.gui === undefined) ? {} : state.gui
    f.currency = (state.currency === undefined) ? {} : state.currency
    f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry
    f.virtualCard = (state.virtualCard === undefined) ? {} : state.virtualCard
    f.payers = (state.payers === undefined) ? {} : state.payers
    f.insuranceTakers = (state.insuranceTakers === undefined) ? {} : state.insuranceTakers

    return f;
}

export default connect(mapStateToProps)(PayerModal);